document.addEventListener('DOMContentLoaded', function () {
  const searchForm = document.querySelector('form[action="/search"]');
  if (!searchForm) return;

  searchForm.addEventListener('submit', function (e) {
    e.preventDefault();

    const searchInput = searchForm.querySelector('input[name="q"]');
    const searchTerm = searchInput ? searchInput.value.trim() : '';

    const hiddenFilter = document.getElementById('collection-filter-input');
    const collectionHandle = hiddenFilter?.value || 'all';

    const currentParams = new URLSearchParams(window.location.search);
    let url;

    if (searchTerm === '') {
      // Empty search - redirect to collection page
      url = new URL(`/collections/${collectionHandle}`, window.location.origin);

      for (const [key, value] of currentParams.entries()) {
        if (
          key !== 'q' &&
          key !== 'collection' &&
          key !== 'filter.p.m.custom.ccbc_book_collection'
        ) {
          url.searchParams.append(key, value);
        }
      }

    } else {
      // Search with query
      url = new URL('/search', window.location.origin);

      for (const [key, value] of currentParams.entries()) {
        if (key !== 'collection' && key !== 'filter.p.m.custom.ccbc_book_collection') {
          url.searchParams.append(key, value);
        }
      }

      url.searchParams.set('q', searchTerm);

      // Only include filter if not searching 'all'
      if (hiddenFilter && collectionHandle !== 'all') {
        url.searchParams.set(hiddenFilter.name, hiddenFilter.value);
        url.searchParams.set('collection', hiddenFilter.value);
      }
    }

    window.location.href = url.toString();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const filterContainer = document.querySelector('.filter-links');
  if (!filterContainer) return;

  const isSearchPage = filterContainer.dataset.pageType === 'true';
  const collectionLinks = filterContainer.querySelectorAll('a[data-collection]');

  collectionLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      const selected = this.getAttribute('data-collection');

      if (isSearchPage) {
        e.preventDefault();

        const params = new URLSearchParams(window.location.search);

        if (selected === 'all') {
          // Remove filter if 'all' is selected
          params.delete('filter.p.m.custom.ccbc_book_collection');
          params.delete('collection');
        } else {
          // Apply filter
          params.set('filter.p.m.custom.ccbc_book_collection', selected);
          params.set('collection', selected);
        }

        window.location.href = `/search?${params.toString()}`;
      } else {
        const url = new URL(this.href, window.location.origin);
        const currentParams = new URLSearchParams(window.location.search);

        for (const [key, value] of currentParams.entries()) {
          if (
            key !== 'collection' &&
            key !== 'filter.p.m.custom.ccbc_book_collection'
          ) {
            url.searchParams.append(key, value);
          }
        }

        e.preventDefault();
        window.location.href = url.toString();
      }
    });
  });
});